<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { useI18n } from "vue-i18n";
import { sectors } from "@/constants/activationSectors";

const { t } = useI18n();
</script>

<template>
  <AccordionComponent>
    <template #title>
      {{ t("faq.sectors.title") }}
    </template>
    <template #faq-content>
      <div class="overflow-x-auto">
        <table
          class="w-full border border-ternary text-base font-normal leading-[21px] text-left text-brown sectors-table"
        >
          <thead class="font-semibold">
            <tr>
              <th class="text-center align-middle border px-3 py-2">
                {{ t("faq.sectors.headers.direction") }}
              </th>
              <th class="border px-3 py-2">
                {{ t("faq.sectors.headers.compas-direction") }}
              </th>
              <th class="border px-3 py-2">
                {{ t("faq.sectors.headers.mountain") }}
              </th>
              <th class="border px-3 py-2">
                {{ t("faq.sectors.headers.name") }}
              </th>
              <th class="border px-3 py-2">
                {{ t("faq.sectors.headers.hieroglyph") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sector, index) in sectors" :key="index">
              <td
                class="text-center align-middle border px-3 py-2"
                rowspan="3"
                v-if="sector.direction !== undefined"
              >
                {{ t(sector.direction) }}
              </td>
              <td class="border px-3 py-2">{{ sector.degree }}</td>
              <td class="border px-3 py-2">
                {{ t(sector.mountain) }}
              </td>
              <td class="border px-3 py-2">
                {{ t(sector.name) }}
              </td>
              <td class="border px-3 py-2">{{ sector.hieroglyph }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("faq.sectors.collapse_btn") }}
    </template>
  </AccordionComponent>
</template>

<style scoped>
.sectors-table tbody tr:nth-child(6n + 1),
.sectors-table tbody tr:nth-child(6n + 2),
.sectors-table tbody tr:nth-child(6n + 3) {
  background-color: #f7f4f3;
}
</style>
